import { makeAutoObservable } from "mobx"

import { DataSourceFile } from "@framework/types/upload"

import EntityCollection from "../utils/EntityCollection"

export default class AvatarUploadedFilesKnowledgeStore {
  constructor() {
    makeAutoObservable(this)
  }

  collectionsMap: Map<string, EntityCollection<DataSourceFile>> = new Map()

  getCollectionKey = (dataCategoryId: string, sourceGroup: string) =>
    `${dataCategoryId}_${sourceGroup}`

  getCollection = (dataCategoryId: string, sourceGroup: string) => {
    const key = this.getCollectionKey(dataCategoryId, sourceGroup)

    if (!this.collectionsMap.has(key)) this.resetCollection(key)

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.collectionsMap.get(key)!
  }

  resetCollection = (collectionKey: string) => {
    this.collectionsMap.set(collectionKey, new EntityCollection())
  }
}
